import { IEntity } from '../../../../lib/types';
import React, { PropsWithChildren } from 'react';
import { ITableRowValues, ITableOptionsConfig } from '../../../_core/table/table.types';
import { IAdminProps, IPersonalCompanyProps } from '../../../_core/core.types';
import { ITableHeaderCell } from '../../../_core/table/table.types';
import { TableWithActions } from '../../../_core/table/table-with-actions.component';

interface IEntityTableProps
  extends PropsWithChildren,
    IAdminProps,
    IPersonalCompanyProps,
    ITableOptionsConfig<IEntity> {
  entities: IEntityTableRowValues[];
}

export interface IEntityTableRowValues extends ITableRowValues {
  entity: IEntity;
}

export const EntityTable: React.FC<IEntityTableProps> = ({
  bordered,
  children,
  isPersonalCompany,
  entities,
  ...rest
}) => {
  const headers: ITableHeaderCell[] = [
    { content: 'Name', sortKey: 'name' },
    { content: 'Status', sortKey: 'deletedAt' },
    { content: 'Main Contact', sortKey: 'mainContact' }
  ];
  if (!isPersonalCompany)
    headers.push({ content: 'Departments', sortKey: 'department' }, { content: 'Locations', sortKey: 'location' });
  headers.push({ content: '' });

  return (
    <>
      <TableWithActions {...rest} bordered={bordered} headers={headers} values={entities}>
        {children}
      </TableWithActions>
    </>
  );
};
